<template>
  <div>
    <div class="header-box" v-if="isH5">
      <PageMbHeader
        :title="$t('取消订单')"
        :transShow="false"
        :transOpen="false"
        :iconShow="!isNewTab"
        @icon-click="back"
      />
    </div>
    <HelpCenterHeader v-if="!isH5"></HelpCenterHeader>
    <div class="content">
      <div class="cancel-result-content">
        <CancelOrderContent>
          <template v-slot:left>
            <div class="img-content">
              <img :src="statusImg" v-img-error alt="" class="img" />
            </div>
          </template>
          <template v-slot:right>
            <div class="info-content">
              <div class="tit">{{ title }}</div>
              <div class="desc">{{ cancelSuccessText }}</div>
              <div class="desc">{{ cancelSuccessTip }}</div>
            </div>
          </template>
        </CancelOrderContent>
      </div>
      <div class="button-content">
        <el-button class="btn" @click="handleConfirm"
          >{{ this.$t('确认') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash-es';
import { mapState } from 'vuex';
import statusImg from '@/assets/images/order/cancel/cancel_result.png';
import CancelOrderContent from '@/components/CancelOrderContent';
import HelpCenterHeader from '@/components/HelpCenterHeader';
import PageMbHeader from '@/components/PageMbHeader';
import { getIsNewTab } from '@/utils/tools';

export default {
  name: 'cancelOrderResult', // 取消结果页面
  components: {
    CancelOrderContent,
    HelpCenterHeader,
    PageMbHeader,
  },
  data() {
    return {
      title: this.$t('取消订单'),
      cancelSuccessText: get(this, '$route.query.cancelSuccessText', ''),
      cancelSuccessTip: get(this, '$route.query.cancelSuccessTip', ''),
      statusImg: statusImg,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    isNewTab() {
      return getIsNewTab();
    },
  },
  methods: {
    handleConfirm() {
      this.goOrderList();
    },
    goOrderList() {
      this.$router.push({
        path: '/order/',
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import '../../control_global.scss';
.content {
  height: calc(100vh - #{$pc_cont_height});
  position: relative;
  max-width: 940px;
  margin: 0 auto;
  padding-bottom: 80px;
}
.button-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: right;
  height: 80px;
  padding-right: 20px;
  background: #ffffff;
  .btn {
    margin: 20px 0 20px 20px;
    min-width: $pc_button_min_width;
  }
}
.cancel-result-content {
  height: 100%;
  overflow-y: auto;
  border-radius: 8px;
  background: #fff;
  .info-content {
    flex: 1;
    position: relative;
    overflow-y: auto;
    .tit {
      margin: 40px auto 20px;
      font-family: 'Aspira Medium';
      font-size: 24px;
      line-height: 28px;
      color: #000000;
      max-width: 500px;
    }
    .desc {
      font-family: 'Aspira Light';
      font-size: 14px;
      line-height: 18px;
      color: #000000;
      margin: 0 auto 20px;
      max-width: 500px;
    }
  }
  .img-content {
    width: 250px;
    height: auto;
    margin: 80px auto 0;
  }
  .img {
    width: 100%;
    height: 100%;
  }
}
// 移动端适配
@media screen and (max-width: 768px) {
  .header-box {
    position: sticky;
    top: 0;
    z-index: 9;
  }
  .cate-header-wrapper {
    position: relative;
  }
  .content {
    margin: 0 0;
    min-height: calc(100vh - #{$h5_btn_height});
    background: #f5f5f7;
    padding: 0 rem(24) $h5_btn_height;
    border-radius: 0;
  }
  .button-content {
    position: fixed;
    bottom: 0;
    padding: rem(38) rem(24);
    background: transparent;
    .btn {
      display: block;
      margin: 0 0;
      width: 100%;
    }
  }
  .cancel-result-content {
    background: #f5f5f7;
    // height: calc(100% - #{$h5_btn_header_height});
    padding: 0 0 $h5_btn_height;
    .cancel-order-content {
      height: auto;
      background: #f5f5f7;
      padding-top: rem(48);
    }
    .img-content {
      background: #f5f5f7;
      width: 100%;
      height: 100%;
      margin-left: 0;
      padding: 0 rem(160);
      margin: 0 auto;
    }
    .img {
      width: 100%;
      height: 100%;
    }
    .right-cont {
      min-height: 0;
    }

    .info-content {
      position: relative;
      max-height: none;
      .tit {
        margin-top: rem(40);
        margin-bottom: rem(24);
        font-family: 'Aspira Medium';
        font-size: rem(36);
        line-height: rem(42);
        color: #000000;
        text-align: center;
      }
      .desc {
        font-family: 'Aspira Light';
        font-size: rem(32);
        line-height: rem(38);
        color: #4a4b5c;
        margin-bottom: rem(20);
      }
    }
    .concact-cont {
      margin-bottom: rem(96);
    }

    .footer-content {
      position: fixed;
      bottom: 0;
      padding-bottom: 0;
      padding: rem(38) rem(24);
      .btn {
        width: 100%;
        display: block;
        margin-bottom: rem(38);
      }
    }
    .icon-outline_phone {
      vertical-align: middle;
    }
  }
}
</style>
